<template><div><h1 id="benutzerstamm" tabindex="-1"><a class="header-anchor" href="#benutzerstamm"><span>Benutzerstamm</span></a></h1>
<p>Benutzerstamm — Stammtabelle der funtrade-User</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Im Benutzerstamm werden alle funtrade-User erfasst. Zusäztlich werden benutzerspezifische Parametrisierungen, wie z.B. Sprache der Bedienoberfläche, festgelegt. Die Zuordnung der <RouteLink to="/referenz/refs/ft.refdata.benutzergruppen.html" title="Benutzergruppen">Benutzergruppen</RouteLink> wird im Frame <RouteLink to="/referenz/refs/ft.refdata.benutzerzuo.html" title="Benutzergruppen zuordnen">Benutzergruppen zuordnen</RouteLink> vorgenommen.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Benutzerverwaltung → Benutzerstamm</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Benutzer</dt>
<dd>Benutzer (wenn möglich eine kurze Bezeichnung, wird für das Login in <span class="emphasis"><em><span class="application">funtrade</span></em></span> verwendet)</dd>
<dt>Benutzername</dt>
<dd>Längere Bezeichnung/Beschreibung zum Benutzer</dd>
<dt>aktiv bis</dt>
<dd>Das Login des Benutzers wird nach diesem Datum deaktiviert.</dd>
<dt>Benutzertyp</dt>
<dd>Typ des Benutzers
<table>
<thead>
<tr>
<th>Benutzertyp</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Standard</td>
<td>Benutzer in der Organisation</td>
</tr>
<tr>
<td>Supportbenutzer</td>
<td>Benutzer die Support für funtrade leisten (in der Regel Arenae-Mitarbeiter)</td>
</tr>
<tr>
<td>Systembenutzer</td>
<td>Interne Systembenutzer welche z.B. regelmässige Jobs starten wie &quot;Dublettenzusammenführungen&quot;, &quot;Mailserver-Domain aktualisieren&quot;, etc.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Sprachcode</dt>
<dd>Sprache der Benutzeroberfläche</dd>
<dt>Drucker</dt>
<dd>Standarddrucker, wird vom System für diesen Benutzer als Standard vorgeschlagen.</dd>
<dt>Authentifizierungsname</dt>
<dd>Authentifizierungsname</dd>
<dt>Authentifizierungsmode</dt>
<dd>Authentifizierungsmode für die Login-Prozedur.| Authentifizierungsmode | Bedeutung |
| --- | --- |
| funtrade | Die Authentifizierung erfolgt durch funtrade |
| extern | Die Authentifizierung erfolgt durch ein externes System z.B. Windows Active Directory |</dd>
<dt>E-Mail</dt>
<dd>Ja = Alle vom Benutzer aufgegebene, abgeschlossene/fehlerhafte Jobs werden per E-Mail benachrichtigt.| E-Mail | Bedeutung |
| --- | --- |
| ja | Alle vom Benutzer aufgegebene, abgeschlossene/fehlerhafte Jobs werden automatisch per E-Mail benachrichtigt. |
| nein | Alle vom Benutzer aufgegebene, abgeschlossene/fehlerhafte Jobs werden nicht automatisch per E-Mail benachrichtigt, aber es besteht die Möglichkeit zum Zeitpunkt der Aufgabe eines Jobs sich manuell per E-Mail benachrichtigen zu lassen. Dies kann im Job-Dialog im Register &quot;Ausgabe&quot; die Check-Box &quot;Ausgabe per E-Mail versenden&quot; anhaken. |</dd>
<dt>E-Mailadresse</dt>
<dd>E-Mailadresse des Benutzers. An diese E-Mail Adresse erfolgen die Benachrichtigungen.</dd>
<dt>Haupteinheit</dt>
<dd>Standardeinheit welche nach dem Login aktiviert ist.</dd>
<dt>Letzter Login</dt>
<dd>Zeitpunkt des letzten erfolgreichen Logins.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="passwortanderung" tabindex="-1"><a class="header-anchor" href="#passwortanderung"><span>Passwortänderung...</span></a></h3>
<p>Mit dieser Funktion kann der Systemadministrator das Passwort eines Benutzers ändern.</p>
<h3 id="drucken" tabindex="-1"><a class="header-anchor" href="#drucken"><span>Drucken...</span></a></h3>
<p>Druckt eine Liste aller Benutzer aus. Die Liste kann auch nach &quot;nur aktive Benutzer&quot; eingeschränkt werden. Die zugeordneten Benutzergruppen können wahlweise unterdrückt oder mit auf die Liste ausgegeben werden.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/benutzerverwaltung.html#Benutzerverwaltung" title="1. Benutzerverwaltung">Benutzerverwaltung</RouteLink></p>
</div></template>


